import React from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentSuccess from "../../assets/Onboarding/PaymentSuccess.png";

export default function OnBoardingSuccess() {
  const navi = useNavigate();

  return (
    <div className="container my-5">
      <div className="bg-white rounded shadow-sm p-4 text-center">
        <div className="blueBanner mb-4">
          <p className="p-2 fw-bold text-white mb-0">Onboarding Successful!</p>
        </div>

        <img
          src={PaymentSuccess}
          alt="Success"
          className="img-fluid mx-auto d-block mb-4"
          style={{ maxHeight: "200px" }}
        />

        <p className="lead text-muted">
          Congratulations! You've successfully completed your onboarding process with Stripe. <br />
          You're now ready to create your club and start offering your services.
        </p>

        <button
          className="saveChanges-button mt-4"
          onClick={() => navi("/CreateClub")}
        >
          Create Your Club
        </button>
      </div>
    </div>
  );
}
